import { DataSourceIDEnum } from '@/models/dataSource';
import { StorageType } from '@/services/dataSources';

export const RESYNCABLE_DATA_SOURCES: Record<DataSourceIDEnum, StorageType | null> = {
  AMAZON_S3: 's3',
  SFTP: 'sftp',
  CSV_FILE: null,
  ENCRYPTED_CSV_FILE: null,
  GOOGLE_TAG_MANAGER: null,
  SALESFORCE: null,
  WEBSITE_JS: null,
};
